import { Accordion, AccordionContent, AccordionItem, Button } from '@kalos/ui';

import { TransactionCreateForm } from './transactionCreateForm/TransactionCreateForm';

export const TransactionCreateAccordion = ({
  isOpen,
  onClose,
  onSave,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSave?: () => void;
}) => {
  return (
    <Accordion collapsible value={String(isOpen)} type="single">
      <AccordionItem value="true">
        <AccordionContent>
          <div className="space-y-4 p-4">
            <div className="flex items-center justify-between gap-2">
              <h3 className="scroll-m-20 text-xl font-semibold tracking-tight">
                Create Transaction
              </h3>
              <Button onClick={onClose} variant="outline">
                Close
              </Button>
            </div>
            <TransactionCreateForm onSave={onSave} />
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
